import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button
} from 'semantic-ui-react'

const CardPerioperativeNursingRecordUX = (props: any) => {
    return(
      <div
        id="CardPerioperativeNursingRecord">
        <div
          id="CardPerioperativeNursingRecordUX-div-2"
          style={{ paddingTop: "4px", marginBottom: "-4px" }}>
          
          <Button
            color={props.containerName === "BasicInfo" ? "blue":  undefined}
            id="CardPerioperativeNursingRecordUX-Button-3"
            name="BasicInfo"
            onClick={props.onSetContainerName}
            style={{marginLeft: "15px"}}>
            {props.languageUX === "en" ? "Basic Info" : "Basic Info"}
          </Button>
          <Button
            color={props.containerName === "StepA-H" ? "blue":  undefined}
            id="CardPerioperativeNursingRecordUX-Button-4"
            name="StepA-H"
            onClick={props.onSetContainerName}>
            {props.languageUX === "en" ? "Step A-H" : "Step A-H"}
          </Button>
          <Button
            color={props.containerName === "OtherForm" ? "blue":  undefined}
            id="CardPerioperativeNursingRecordUX-Button-5"
            name="OtherForm"
            onClick={props.onSetContainerName}>
            {props.languageUX === "en" ? "Other Form" : "Other Form"}
          </Button>
          <Button
            color={props.containerName === "ByEquipment" ? "blue":  undefined}
            id="CardPerioperativeNursingRecordUX-Button-6"
            name="ByEquipment"
            onClick={props.onSetContainerName}>
            {props.languageUX === "en" ? "By Equipment" : "By Equipment"}
          </Button>
          <Button
            color={props.containerName === "PostopeartiveNursingRecord" ? "blue":  undefined}
            id="CardPerioperativeNursingRecordUX-Button-7"
            name="PostopeartiveNursingRecord"
            onClick={props.onSetContainerName}>
            {props.languageUX === "en" ? "Postopeartive Nursing Record" : "Postopeartive Nursing Record"}
          </Button>
        </div>
        <hr
          id="CardPerioperativeNursingRecordUX-hr-9">
        </hr>
      </div>
    )
}


export default CardPerioperativeNursingRecordUX

export const screenPropsDefault = {}

/* Date Time : Fri Oct 31 2025 04:20:16 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecord"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ paddingTop: \"4px\", marginBottom: \"-4px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "Basic Info",
          "valueEN": "Basic Info"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"BasicInfo\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-Button-3"
        },
        "name": {
          "type": "value",
          "value": "BasicInfo"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "Step A-H",
          "valueEN": "Step A-H"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"StepA-H\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-Button-4"
        },
        "name": {
          "type": "value",
          "value": "StepA-H"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "Other Form",
          "valueEN": "Other Form"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"OtherForm\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-Button-5"
        },
        "name": {
          "type": "value",
          "value": "OtherForm"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "By Equipment",
          "valueEN": "By Equipment"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"ByEquipment\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-Button-6"
        },
        "name": {
          "type": "value",
          "value": "ByEquipment"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "Postopeartive Nursing Record",
          "valueEN": "Postopeartive Nursing Record"
        },
        "color": {
          "type": "code",
          "value": "props.containerName === \"PostopeartiveNursingRecord\" ? \"blue\":  undefined"
        },
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-Button-7"
        },
        "name": {
          "type": "value",
          "value": "PostopeartiveNursingRecord"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSetContainerName"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPerioperativeNursingRecordUX-hr-9"
        }
      },
      "seq": 9,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardPerioperativeNursingRecordUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
